import React from 'react';

import ToggleSwitch from '@commons/ToggleSwitch';

import styles from './cookieCategoryControl.scss';

interface CookieCategoryControlProps {
  id: string;
  title: string;
  value: boolean;
  onChange: (...args: unknown[]) => unknown;
  disabled?: boolean;
  requiredLabel: string;
}

function CookieCategoryControl({
  id,
  title,
  value,
  onChange,
  disabled = false,
  requiredLabel
}: CookieCategoryControlProps) {
  return (
    <div className={styles.wrapper}>
      {disabled ? (
        <p className={styles.requiredLabel}>{requiredLabel}</p>
      ) : (
        <ToggleSwitch
          id={id}
          value={value}
          onChange={() => onChange(id)}
          disabled={disabled}
          ariaLabel={title}
        />
      )}
    </div>
  );
}

export default CookieCategoryControl;
